module.exports = __webpack_public_path__ + "static/media/plus-blue.aea5d8c3.svg";